var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CLIENTS_DATA } from '../const/clients';
export var isCertificateSelected = function (certificate, selectedCertificates) {
    return selectedCertificates === null || selectedCertificates === void 0 ? void 0 : selectedCertificates.some(function (cer) { return cer.certificateNumber === certificate.certificateNumber; });
};
export var sortCertificatesByAscExpiryDate = function (certificatesData) {
    var newArray = certificatesData ? __spreadArray([], certificatesData, true) : [];
    return newArray
        .sort(function (a, b) {
        var dateA = new Date(a.certificateExpiryDate).getTime();
        var dateB = new Date(b.certificateExpiryDate).getTime();
        return dateA - dateB;
    })
        .map(function (certificate, index) {
        return __assign(__assign({}, certificate), { certificateIndex: newArray.length - index - 1 });
    });
};
export var sortCertificatesByIndex = function (certificates) {
    return certificates.sort(function (a, b) {
        return (b.certificateIndex === undefined ? Infinity : b.certificateIndex) -
            (a.certificateIndex === undefined ? Infinity : a.certificateIndex);
    });
};
export var isCertificateExpiringSoon = function (client, certificateExpiryDate) {
    if (!(client in CLIENTS_DATA)) {
        return false;
    }
    var daysToAdd = CLIENTS_DATA[client].certificateExpirationDays;
    var currentDate = new Date();
    var expirationDate = new Date(certificateExpiryDate);
    currentDate.setDate(currentDate.getDate() + daysToAdd);
    return expirationDate <= currentDate;
};
